
import React from 'react';
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';

import TabComponent from '../TabComponent';

import TotalCashTransactionComplete from './TotalCashTransactionComplete';
import TotalNetBankingTransactionComplete from './TotalNetBankingTransactionComplete';

const TotalTransactionCompleteTabs = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setHeaderName("Total Transaction Complete"));
    }, [dispatch]);

    const tabsHeadData = [
        { label: 'Cash', icon: "" },
        { label: 'Net Banking', icon: "" },
    ];

    const tabsComponent = [
        <TotalCashTransactionComplete />,
        <TotalNetBankingTransactionComplete />,
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default TotalTransactionCompleteTabs;
